// @core/api/endpoints/team/list_my_team_invitations.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTeamInvitationsResponse,
} from '../../../types/team';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/team';

/**
 * List my team invitations
 * Returns all invitations received by the current user across all teams. No team-specific authorization required — filters by the caller's profile ID.
 */
export async function ListMyTeamInvitations(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTeamInvitationsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/my-invitations`;
  const requestOptions = options;
  return client.get<ListTeamInvitationsResponse>(requestPath, { ...requestOptions, params });
}
